import React from "react"
import {
  Create,
  Edit,
  Show,
  BooleanInput,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
} from "admin-on-rest"
import TemplateForm from "./TemplateForm"
import TemplateShowLayout from "./TemplateShowLayout"

const postDefaultValue = { title: "", slug: "", active: false, content: [] }

export const TemplateCreate = props => (
  <Create {...props}>
    <TemplateForm
      {...props}
      defaultValue={postDefaultValue}
      statusForm={"create"}
    >
      <TextInput label="resources.contents.field.title" source="title" />
      <TextInput label="resources.contents.field.slug" source="slug" />
      <BooleanInput label="resources.contents.field.active" source="active" />
      <ReferenceArrayInput
        label="resources.contents.field.collections"
        source="collections"
        reference="collections"
        allowEmpty
        perPage={10}
      >
        <SelectArrayInput optionText="name" options={{ fullWidth: true }} />
      </ReferenceArrayInput>
    </TemplateForm>
  </Create>
)

export const TemplateEdit = props => (
  <Edit {...props}>
    <TemplateForm
      {...props}
      defaultValue={postDefaultValue}
      statusForm={"edit"}
    >
      <TextInput label="resources.contents.field.title" source="title" />
      <TextInput label="resources.contents.field.slug" source="slug" />
      <BooleanInput label="resources.contents.field.active" source="active" />
      <ReferenceArrayInput
        label="resources.contents.field.collections"
        source="collections"
        reference="collections"
        allowEmpty
        perPage={1000}
      >
        <SelectArrayInput optionText="name" options={{ fullWidth: true }} />
      </ReferenceArrayInput>
    </TemplateForm>
  </Edit>
)

export const TemplateShow = props => (
  <Show {...props}>
    <TemplateShowLayout {...props} />
  </Show>
)



// WEBPACK FOOTER //
// ./src/contents/Create.js